import React from "react";
import kakaoIcon from "../assets/kakao.png";
import instagramIcon from "../assets/instagram.png";
import bandIcon from "../assets/band.png";
import airbnbIcon from "../assets/airbnb.png";

import styles from "./FloatingButton.module.scss";

const handleClick = (type) => {
  if (type === "airbnb") {
    window.open("https://www.airbnb.co.kr/users/profile/1487962631695112935", "_blank");
  } else if (type === "kakao") {
    window.Kakao.Link.sendDefault({
      objectType: "feed",
      content: {
        title: "스테이 무릉도원",
        description: "아름다운 추억과 즐거운 행복을 만들어 가시길 바랍니다. :)",
        imageUrl:
          "https://user-images.githubusercontent.com/26598542/60029329-e7a70e00-96db-11e9-8423-1f58cd367765.jpg",
        link: {
          mobileWebUrl: "https://www.mrpension.kr/",
          webUrl: "https://www.mrpension.kr/",
        },
      },
      buttons: [
        { title: "웹으로 보기", link: { mobileWebUrl: "https://www.mrpension.kr/", webUrl: "https://www.mrpension.kr/" } },
        { title: "앱으로 보기", link: { mobileWebUrl: "https://www.mrpension.kr/", webUrl: "https://www.mrpension.kr/" } },
      ],
    });
  } else if (type === "band") {
    window.open("https://band.us/band/80019203");
  } else {
    window.open("https://www.instagram.com/mrpension");
  }
};

const BUTTONS = [
  { type: "band",      icon: bandIcon,      alt: "band" },
  { type: "kakao",     icon: kakaoIcon,     alt: "kakao" },
  { type: "instagram", icon: instagramIcon, alt: "instagram" },
  { type: "airbnb",   icon: airbnbIcon,    alt: "airbnb" },
];

const FloatingBar = () => (
  <div className={styles.bar}>
    {BUTTONS.map((btn, i) => (
      <React.Fragment key={btn.type}>
        {i > 0 && <div className={styles.divider} />}
        <div className={styles.btn} onClick={() => handleClick(btn.type)}>
          <img src={btn.icon} alt={btn.alt} className={styles.img} />
        </div>
      </React.Fragment>
    ))}
  </div>
);

export default FloatingBar;



// WEBPACK FOOTER //
// ./src/App/pages/Home/components/FloatingButton.jsx